import React from 'react';

interface SEOProps {
  title: string;
  description: string;
  url: string;
  type?: 'website' | 'article';
  image?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

export const SEOHead: React.FC<SEOProps> = ({
  title,
  description,
  url,
  type = 'website',
  image = 'https://gameobsidian.com/images/logo.webp',
  publishedTime,
  modifiedTime,
}) => {
  const fullUrl = `https://gameobsidian.com${url}`;

  return (
    <>
      <title>{title} | GameObsidian</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={fullUrl} />
    </>
  );
};

export const generateJSONLD = (data: {
  type: 'WebSite' | 'Article' | 'Organization' | 'FAQPage' | 'BreadcrumbList';
  [key: string]: any;
}): string => {
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': data.type,
    ...data,
  };

  return JSON.stringify(baseSchema);
};

export const WebsiteJSONLD = () => {
  const schema = generateJSONLD({
    type: 'WebSite',
    name: 'GameObsidian',
    url: 'https://gameobsidian.com',
    description: 'Comprehensive UK casino offer reviews and comparisons',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://gameobsidian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  });

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />;
};

export const OrganizationJSONLD = () => {
  const schema = generateJSONLD({
    type: 'Organization',
    name: 'GameObsidian',
    url: 'https://gameobsidian.com',
    logo: 'https://gameobsidian.com/images/logo.webp',
    sameAs: [
      'https://facebook.com/gameobsidian',
      'https://twitter.com/gameobsidian',
      'https://instagram.com/gameobsidian',
    ],
  });

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />;
};

